var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, } from 'class-validator';
import { GetManyQueryDto } from '../../../classes/common/request/get-many-query.dto';
import { TransformBoolean } from '../../../decorators';
import { VehicleModelState, VehicleModelType } from '../../../enums';
import { PartialType } from '../../../utils';
export class GetManyVehiclesQueryDto extends PartialType(GetManyQueryDto) {
}
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManyVehiclesQueryDto.prototype, "garageId", void 0);
__decorate([
    TransformBoolean(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetManyVehiclesQueryDto.prototype, "isInUse", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManyVehiclesQueryDto.prototype, "branchId", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManyVehiclesQueryDto.prototype, "vehicleModelId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyVehiclesQueryDto.prototype, "vehicleNumberKeyword", void 0);
__decorate([
    IsEnum(VehicleModelState),
    IsOptional(),
    __metadata("design:type", String)
], GetManyVehiclesQueryDto.prototype, "state", void 0);
__decorate([
    IsEnum(VehicleModelType),
    IsOptional(),
    __metadata("design:type", String)
], GetManyVehiclesQueryDto.prototype, "vehicleModelType", void 0);
__decorate([
    TransformBoolean(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetManyVehiclesQueryDto.prototype, "hasExpirationDate", void 0);
__decorate([
    TransformBoolean(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetManyVehiclesQueryDto.prototype, "isAssigned", void 0);
__decorate([
    TransformBoolean(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetManyVehiclesQueryDto.prototype, "withMaintenanceAndAccidents", void 0);
